(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('WhoswhoMapController', WhoswhoMapController);

    WhoswhoMapController.$inject = ['Principal', 'Whoswho', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'EquipeCommerciale', 'Picture'];

    function WhoswhoMapController(Principal, Whoswho, ParseLinks, AlertService, $state, pagingParams, paginationConstants, EquipeCommerciale, Picture) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.persons = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.ec;
        vm.firstLetter = firstLetter;
        vm.geoJson;
        vm.loadAll();
        vm.flyToPerson = flyToPerson;
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
            EquipeCommerciale.getByEmail({email: account.email}, function(result) {
                vm.ec = result;
            });
        });

        function loadAll () {
            Whoswho.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            Whoswho.queryMap({}, onSuccessMap, onErrorMap);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.page = pagingParams.page;
            vm.persons = data;
            vm.persons.forEach(function(p) {
                loadPicture(p);
            });
        }

        function onErrorMap(error) {
            AlertService.error(error.data.message);
        }


        function onSuccessMap(data) {
            vm.geoJson = data;
            loadMap(vm.geoJson);
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }


        function clear () {
            vm.user = {
                id: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc') + ', ignoreCase'];
            if (vm.predicate !== 'lastName') {
                result.push('lastName');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function firstLetter(name) {
            return name && name.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace('æ', 'ae').charAt(0).toUpperCase();
        }

        function flyToPerson(personToFly) {
            var feature = vm.geoJson.features.find(function(el) {
                return el.properties.id === personToFly.user.id;
            })
            flyTo(feature.geometry.coordinates[0], feature.geometry.coordinates[1], feature.properties.message);
        }

        function loadPicture(person){
            if (person.profile && person.profile.pictureContentType){
                Picture.getProfilePicture(person.profile.id).then(function (response) {
                    person.profile.picture=response;
                }, function (response) {
                });
            }
        }


    }
})();
